import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AtolSetupProblemType as SchemaAtolSetupProblemType } from '../schemas/AtolSetupProblemType';
import { type AtolSetupResponse as SchemaAtolSetupResponse } from '../schemas/AtolSetupResponse';
import { type Problem as SchemaProblem } from '../schemas/Problem';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const SetupAtolIntegrationContentType = 'multipart/form-data' as const;
export type SetupAtolIntegrationRequest = {
    /**
     * @format binary
     */
    file: string;
};
export type SetupAtolIntegrationResponses = LinkCommonErrorResponses & {
    /**
     * @description ATOL integration setup result
     */
    '200': {
        'application/json': SchemaAtolSetupResponse;
    };
    /**
     * @description Invalid credentials
     */
    '401': {
        'application/json': SchemaProblem & {
            type: SchemaAtolSetupProblemType;
        };
    };
    /**
     * @description Store INN does not match integration data INN
     */
    '409': {
        'application/json': SchemaProblem & {
            type: SchemaAtolSetupProblemType;
        };
    };
    /**
     * @description Invalid integration file
     */
    '422': {
        'application/json': SchemaProblem & {
            type: SchemaAtolSetupProblemType;
        };
    };
};
export type SetupAtolIntegrationResponseSuccess = SetupAtolIntegrationResponses['200']['application/json'];
export type SetupAtolIntegrationSearchParams = undefined;
export type SetupAtolIntegrationPathParameters = undefined;
export const SetupAtolIntegrationUrl = '/integrations/atol/setup' as const;
export const SetupAtolIntegrationMethod = 'POST' as const;
export const getSetupAtolIntegrationUrl = (_params?: SetupAtolIntegrationPathParameters) => SetupAtolIntegrationUrl;
